import { useState } from 'react'
import copyString from 'features/common/utils/copyString'

export const useCopyValue = (msg = 'common.button.copy', copiedMsg = 'common.button.copiedToClipboard') => {
  const [message, setMessage] = useState(msg)

  const copy = (text: string) => {
    copyString(text)
    setMessage(copiedMsg)
    setTimeout(() => setMessage(msg), 1000)
  }

  return {
    message,
    copy
  }
}
